"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isGroupChallenge = _interopRequireDefault(require("./isGroupChallenge"));

var getParticipants = function getParticipants(_ref) {
  var users = _ref.users;

  if (users) {
    return Object.keys(users).reduce(function (count, status) {
      var _users$total = users[status].total,
          total = _users$total === void 0 ? 0 : _users$total;
      return count + total;
    }, 0);
  }

  return 0;
};

var getChallengeStats = function getChallengeStats(_ref2) {
  var challenge = _ref2.challenge,
      stats = _ref2.stats;

  var _ref3 = (stats === null || stats === void 0 ? void 0 : stats.users) || {},
      _ref3$SUCCESS = _ref3.SUCCESS;

  _ref3$SUCCESS = _ref3$SUCCESS === void 0 ? {} : _ref3$SUCCESS;
  var _ref3$SUCCESS$total = _ref3$SUCCESS.total,
      finishers = _ref3$SUCCESS$total === void 0 ? 0 : _ref3$SUCCESS$total;
  var userParticipants = getParticipants({
    users: stats === null || stats === void 0 ? void 0 : stats.users
  });
  var globalUsersParticipants = getParticipants({
    users: stats === null || stats === void 0 ? void 0 : stats.globalUsers
  });
  return {
    participants: (0, _isGroupChallenge["default"])(challenge) ? challenge.participants || 0 : userParticipants,
    finishers: finishers,
    globalUsersParticipants: globalUsersParticipants
  };
};

var _default = getChallengeStats;
exports["default"] = _default;
//# sourceMappingURL=getChallengeStats.js.map